const devEnv = {
  IS_PROD: false,
  APP_URL: 'http://localhost:3000',
  API_URL: 'http://localhost:8787/v2',
  //API_URL: 'https://api.dayschedule.com/v2',
  DOMAIN: 'localhost',
};

const prodEnv = {
  IS_PROD: true,
  APP_URL: 'https://app.dayschedule.com',
  API_URL: 'https://api.dayschedule.com/v2',
  DOMAIN: 'dayschedule.com',
};

const env = import.meta.env.DEV ? devEnv : prodEnv;

export default env;
